export default [
  {
    path: "/pa",
    name: "pa",
    meta: {
      title: "PA派单",
      requireAuth: true
    },
    component: () => import("./pa.vue")
  }
];
